import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharingService } from '../../services/sharing.service';
import { WebpayService } from '../../services/webpay.service';
import { environment } from '../../../../environments/environment';
import { SystemService } from 'src/app/base/services/system.service';
import { ErroresHandler } from 'src/app/base/tools/handler/error.handler';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})

export class HomeComponent {
    constructor(private router: Router,
        private webpay: WebpayService,
        private sharingService: SharingService,
        private systemService: SystemService,
        private erroresHandler: ErroresHandler,) { }

    ngOnInit() {
        this.obteneruid();
    }

    private async obteneruid() {
        this.systemService.setLoading(true);

        /* no se dejó params (separacion por parámetros funcion getQueryParams de webpay.service.ts) 
        para que el sistema en caso de que manipulen la url y no venga '&err=' , el "let idWebpay: string = window.location.href.split('?uid=')[1];"
        agarre todo y abajo lance error ya que el uid no va a existir.
        */
        if (window.location.href.toLowerCase().includes('&err=')) {
            this.router.navigate(['/errorRetorno']);
        } else {

            let idWebpay: string = window.location.href.split('?uid=')[1];
            /**
             * aqui obtengo la respuesta del redis de webpay
             */
            if (idWebpay != null) {

                try {

                    let webpayResponse = await this.webpay.getInformacion(idWebpay);

                    if (!webpayResponse.datos.hasOwnProperty('webpayInicial')) {

                        let resp = await this.webpay.setTokenWebpay(idWebpay);

                        this.sharingService.sharingObservableData = JSON.stringify(resp);

                        this.router.navigate(['/redirect']);

                    } else {

                        if (webpayResponse.datos.hasOwnProperty('RespuestaWebpay')) {

                            this.sharingService.sharingObservableData = JSON.stringify(webpayResponse);

                            switch (webpayResponse.datos.RespuestaWebpay.vista) {
                                case 'aprobado':
                                    this.router.navigate([`/success`]/*, {queryParams:   {data: webpayResponse},}*/);
                                    break;
                                case 'rechazado':
                                    this.router.navigate([`/reject`]/*, {queryParams:   {data: webpayResponse},}*/);
                                    break;
                                case 'error':
                                    this.router.navigate([`/errorWebpay`]/*, {queryParams:   {data: webpayResponse},}*/);
                                    break;
                            }
                        } else {
                            /* sin respuesta desde webpay */
                            // queda en home
                        }

                    }
                } catch (e) {
                    this.erroresHandler.processError(e, 'page');
                }
            } else {
                /* 
               sin uid, queda en home y no hace nada
               */
            }
        }
        this.systemService.setLoading(false);
    }
}
